export const formatHeadline = (headline: string) => {
    let formattedHeadline = String(headline);
    formattedHeadline = formattedHeadline.replace(/: Markets Wrap/, "");
    formattedHeadline = formattedHeadline.replace(/\(Audio\)/i, "");
    formattedHeadline = formattedHeadline.replace(/\(video\)/i, "");
    formattedHeadline = formattedHeadline.replace(/\(podcasts?\)/i, "");
    formattedHeadline = formattedHeadline.replace(/\s+/g, " ");

    return formattedHeadline;
};
